var map = {
	"./applab/skins": 2249,
	"./bounce/skins": 2655,
	"./craft/agent/skins": 2659,
	"./craft/code-connection/skins": 2660,
	"./craft/designer/skins": 2658,
	"./craft/simple/skins": 2657,
	"./flappy/skins": 2661,
	"./jigsaw/skins": 2674,
	"./maze/skins": 1866,
	"./netsim/skins": 2724,
	"./p5lab/skins": 2114,
	"./studio/skins": 2726,
	"./studio/starwars/skins": 2275,
	"./turtle/skins": 2314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4054;